module.exports = __webpack_public_path__ + "static/game-of-life-1ffe67497127dd5fad4ddf470e0f2fbb.gif";